var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.378 10.735 5.5-5.5-2.613-2.613-5.5 5.5a.594.594 0 0 0-.155.275L0 11.5l3.103-.61c.104-.026.199-.08.275-.155Zm7.275-7.276a1.184 1.184 0 0 0 0-1.674L9.715.847a1.184 1.184 0 0 0-1.674 0l-.939.938 2.613 2.613.938-.939Z",
    fill: "#4A5567"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.69a0e2f7e5332d35d11fc683c4440a60.svg";
export { ForwardRef as ReactComponent };